import { PDKDeliveryQueueIcon } from '@/components/ui/pdk-icons';
import { COMBO_BOX_OPTIONS_2 } from '../combobox-popovers/all-filters-combobox-popover';
import type {
  DeliveryQueuedFilterChipProps,
  DeliveryQueuedFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const DeliveryQueuedFilterChip = (props: DeliveryQueuedFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<'delivery_queued', DeliveryQueuedFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={({ children }) => <div>{children}</div>}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_2.find((option) => option.value === 'delivery_queued')
          ?.icon
      }
      filterName="Deal"
      filterQuantifier={{
        singular: 'delivery queued',
        plural: 'delivery queued',
      }}
      SelectedFilterBadge={() => <PDKDeliveryQueueIcon className="size-3.5" />}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      hideFilterComboBoxPopover
    />
  );
};

export default DeliveryQueuedFilterChip;
